<div class="app-c-search-filed">
    <span class="icon-search">
        <sra-svg-icons name="search" title="Search" className="icon-size-16" ariaHidden="false" focusable="false" />
    </span>
    <input type="search" [formControl] ="searchControl" [id]="id" [attr.placeholder]="placeholder" [disabled]="disabled" class="app-c-btn" />
</div>